import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './components/Login/LoginPage';
import Dashboard from './components/Dashboard/DashboardPage';
import ReportPage from './components/Reports/ReportPage';
import SavedReport from './components/SavedReports/SavedReport';
import DetailedSavedReport from './components/SavedReports/DetailedSavedReport';
import ProtectedRoute from './context/ProtectedRoute';
import Users from './components/User/UserPage';
import EditUser from './components/User/EditUser';
import ManageJobs from './components/CountsOrders/ManageJob';
import NewRequestWrapper from './components/CountsOrders/NewRequestWrapper';
import { ThemeProvider, createTheme } from "@mui/material";
import { appInsights } from './AppInsights';

const theme = createTheme({
  typography: {
    fontFamily: "Manrope, 'sans-serif'",
    fontSize: 14
  }
})

const AppRoutes: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    appInsights.trackPageView({ name: location.pathname });
  }, [location]);
  
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/:reportId"
        element={
          <ProtectedRoute>
            <ReportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/savedreports"
        element={
          <ProtectedRoute>
            <SavedReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/detailedsavedreport"
        element={
          <ProtectedRoute>
            <DetailedSavedReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/manage-users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/manage-users/edit/:id"
        element={
          <ProtectedRoute>
            <EditUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-jobs"
        element={
          <ProtectedRoute>
            <ManageJobs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-jobs/new-request"
        element={
          <ProtectedRoute>
            <NewRequestWrapper />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider theme={theme} >
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
